import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DisplayPost } from '../../models/publication';
import { Subscription, Observable, fromEvent, BehaviorSubject, switchMap, forkJoin, of } from 'rxjs';
import { PostService, PostsFluxType } from '../../services/post';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { entranceAnimation } from '../../animations/entrances.animation';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { catchError, debounceTime, delay, filter, finalize, map, shareReplay, take, tap } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';
import { MISC_CONST } from '../../../utils/const/misc';
import { RequestOrder } from '../flux-options/flux-options-order/flux-options-order.component';
import { ToastrService } from '../../services/utilities/toastr.service';
import { UserStoreService } from '../../services/state-management/user-store.service';
import { distinctHydraMember, filterNullOrUndefined, filterUndefined, HydraCollection, Kaza, User } from '@adeo/ngx-kozikaza-api';
import { KzIconsRegistryService } from '../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsMemoriesMonochrome } from '../../../kz-ui/ui/icon/generated-icons/kzIcons-memories-monochrome.icon';
import { kzIconsIdea } from '../../../kz-ui/ui/icon/generated-icons/kzIcons-idea.icon';
import { moodIcons } from '../../../kz-ui/ui/icon/groups/kz-icons-group-mood';
import { MediaQueriesService } from '../../services/utilities/media-queries.service';
import { FavoriteService, PostPrivacy } from '@adeo/ngx-kozikaza-api/post';
import { postSubResources } from '../../../utils/const/post';
import { HttpParams } from '@angular/common/http';
import { RoutesService } from 'src/app/shared/services/routes/routes.service';
import { kzIconsInfos } from 'src/app/kz-ui/ui/icon/kz-icons';
import { ModalScreenTutoComponent } from '../pro/modal-infos/modal-screen-tuto/modal-screen-tuto.component';
import { ModalService } from 'src/app/utils/modals/modals.service';
import { SharedService } from '../../services/utilities/shared.service';

@Component({
  selector: "app-posts-flux",
  templateUrl: "./posts-flux.component.html",
  styleUrls: ["./posts-flux.component.scss"],
  animations: [entranceAnimation],
  encapsulation: ViewEncapsulation.None,
 // changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostsFluxComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private postsSubscription: Subscription;
  private postsNewSubscription: Subscription;
  protected paramSubscription: Subscription;
  private timerSubscription: Subscription;
  private resizeSubscription: Subscription;
  private myTagsSubscription: Subscription;


  private forceUpdate = false;
  public postsList: Array<DisplayPost> = [];
  public postLoading = false;
  public requestDoneOnce = false;
  public itemsPerPage: number = MISC_CONST.NB_POSTS_OFFSET;
  public nbPostsOffset: number = MISC_CONST.NB_POSTS_OFFSET;
  public params = {
    itemsPerPage: this.itemsPerPage,
    page: 1,
    order: { createdAt: RequestOrder.DESC },
    privacy: null,
    kaza: null,
    author: null
  };
  nbMemories = 0;

  public queryParams: Params;

  protected userLogged: User;
  protected userLoggedIsAdmin: boolean;
  public showOptionFilter = false;
  protected kaza$: BehaviorSubject<Kaza> = new BehaviorSubject<Kaza>(null);
  private downloadSubscription: Subscription | null = null;
  @Input()
  set kaza(kaza: Kaza) {
    this.kaza$.next(kaza);
  }

  get kaza(): Kaza {
    return this.kaza$.getValue();
  }

  public kazaOfLoggedUser = false;
  public activeFilters = [];

  protected forceFirstPost = false;
  @Input() infiniteScrollDisabled = false;
  @Input() nbColumns = 1;
  @Input() itemWidth = 280;
  @Input() itemMargin = 10;
  @Input() intranceDelay = 50;
  @Input() intranceTime = 150;
  @Input() showEmptyVisuel = true;
  @Input() smallItem = false;
  @Input() noEmptyMsg = false;
  public intranceAnimPage = 0;
  public platform: string;
  public isDownloading = false ;

  // Todo : define request types:
  // - discover
  // - my followes
  // - explore
  // - favorites
  @Input() requestType: PostsFluxType = "posts";

  /* Options */
  @Input() showOptionOrder = true;
  @Output() postsFound = new EventEmitter<boolean>();
  @Output() count = new EventEmitter<number>();
  @Input() requestParams: any = null;
  @Input() emptyMessage: string = null;
  @Input() refresh = false;
  @Output() offsetLoaded?: EventEmitter<number> = new EventEmitter();

  @Input() isProKaza = false;

  @ViewChild("kzGrid", { static: false }) kzGrid: ElementRef;

  public screenIsDownloading = false;
  
  constructor(
    protected postService: PostService,
    protected toastrService: ToastrService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected readonly userStoreService: UserStoreService,
    protected readonly kzIconsRegistryService: KzIconsRegistryService,
    protected readonly mediaQueriesService: MediaQueriesService,
    protected readonly favoriteService: FavoriteService,
    protected readonly routesService: RoutesService,
    protected _modalService:ModalService,
    protected sharedService:SharedService, 
  ) {
    this.kzIconsRegistryService.registerIcons([
      kzIconsMemoriesMonochrome,
      kzIconsIdea,
      kzIconsInfos,
      ...moodIcons
    ]);
    this.postsList = [];
    if (isPlatformBrowser(this.platformId)) {
      this.resizeSubscription = fromEvent(window, "resize")
        .pipe(debounceTime(100))
        .subscribe(event => {
          this.setNbColumns(this.kzGrid.nativeElement.offsetWidth);
        });
    }
    this.platform = isPlatformBrowser(this.platformId) ? "browser" : "server";
  }

  ngAfterViewInit() {
    this.setNbColumns(this.kzGrid.nativeElement.offsetWidth);
    this.cdr.detach();
  }

  private setNbColumns(containerWidth: number) {
    if (containerWidth) {
      this.nbColumns = Math.trunc(
        containerWidth / (+this.itemWidth + 2 * this.itemMargin)
      );
      this.cdr.detectChanges();
    }
  }

  ngOnInit(): void {
    this.loadPosts();
    this.getMyKazaPosts();
  }

  // Opening component from Template (use Component @Input)
  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        if (
          (propName === "requestType" &&
            this.requestType &&
            changes.requestType &&
            !changes.requestType.firstChange) ||
          (propName === "requestParams" &&
            changes.requestParams &&
            !changes.requestParams.firstChange) ||
          (propName === "refresh" &&
            changes.refresh &&
            !changes.refresh.firstChange)
        ) {
          this.unsubAll();
          this.forceUpdate = true;
          this.loadPosts();
        }
      }
    }
  }

  ngOnDestroy() {
    this.unsubAll();
    if (this.resizeSubscription && !this.resizeSubscription.closed) {
      this.resizeSubscription.unsubscribe();
    }
    if (this.downloadSubscription) {
      this.downloadSubscription.unsubscribe();
      this.downloadSubscription = null;
    }
  }

  private loadPosts() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.params = this.requestParams || this.params;
    this.paramSubscription = this.initParams()
      .pipe(
        catchError(err => {
          this.toastrService.error(
            $localize`:@@toast.error_try_again:An error has occurred. Please try again`
          );
          return throwError(err);
        }),
        switchMap(() => this.mediaQueriesService.isMobile()),
        tap(isMobile => {
          this.nbPostsOffset = isMobile
            ? MISC_CONST.NB_POSTS_OFFSET_MOBILE
            : MISC_CONST.NB_POSTS_OFFSET;
        }),
        switchMap(u => this.updatePostList(1)),
        filter(
          () =>
            this.page === 1 &&
            !this.routesService.routeHasAnOutlet() &&
            isPlatformBrowser(this.platformId)
        ),
        delay(1000),
        switchMap(() => this.updatePostList())
      )
      .subscribe();
  }

  protected unsubAll() {
    if (this.paramSubscription && !this.paramSubscription.closed) {
      this.paramSubscription.unsubscribe();
    }
    if (this.postsSubscription && !this.postsSubscription.closed) {
      this.postsSubscription.unsubscribe();
    }
    if (this.postsNewSubscription && !this.postsNewSubscription.closed) {
      this.postsNewSubscription.unsubscribe();
    }
    if (this.paramSubscription && !this.paramSubscription.closed) {
      this.paramSubscription.unsubscribe();
    }
    if (this.timerSubscription && !this.timerSubscription.closed) {
      this.timerSubscription.unsubscribe();
    }
    if (this.myTagsSubscription && !this.myTagsSubscription.closed) {
      this.myTagsSubscription.unsubscribe();
    }
  }

  initParams(): Observable<User> {
    return this.userStoreService.userStore.pipe(
      filterUndefined(),
      distinctHydraMember(),
      tap(data => {
        this.forceUpdate = false;
        this.userLogged = data;
        this.userLoggedIsAdmin = this.userStoreService.isAdmin;
        if (!this.userLoggedIsAdmin) {
          this.params.privacy = [];
          this.params.privacy[0] = PostPrivacy.Public;
        }
      })
    );
  }

  set page(n: number) {
    this.params.page = n;
  }

  get page(): number {
    return this.params.page;
  }

  set requestOrder(requestOrder: RequestOrder) {
    const keys = Object.keys(this.params.order);
    if (keys.length) {
      keys.forEach(key => (this.params.order[key] = requestOrder));
    } else {
      this.params.order = { createdAt: requestOrder };
    }
    this.postsSubscription = this.updatePostList(1).subscribe();
  }

  get requestOrder(): RequestOrder {
    const keys = Object.keys(this.params.order);
    return this.params.order
      ? keys.length
        ? this.params.order[keys[0]]
        : this.params.order.createdAt
      : RequestOrder.DESC;
  }
  get favoriteRequest(): Observable<HydraCollection<DisplayPost>> {
    return this.favoriteService
      .getFavorites([{ post: postSubResources }], {
        refresh: true,
        query: new HttpParams({
          fromObject: {
            page: this.page,
            author: this.userStoreService.user["@id"],
            "exists[post]": "true"
          }
        })
      })
      .pipe(
        map(favoriteCollection => {
          let members = favoriteCollection["hydra:member"];
          const postsCollection: HydraCollection<DisplayPost> = {
            ...favoriteCollection,
            "hydra:member": members.map(
              favorite => favorite.post as DisplayPost
            )
          };
          return postsCollection;
        })
      );
  }

  updatePostList(
    page: number = null
  ): Observable<HydraCollection<DisplayPost>> {
    const hydraMember = "hydra:member";
    this.postLoading = true;
    this.page = page ? page : this.page + 1;
    this.intranceAnimPage = this.page - 2;
    this.postsList = page === 1 ? [] : this.postsList;
    this.cdr.detectChanges();
    // when first page, load half quantity of posts
    const pageTmp =
      this.page === 3 && this.itemsPerPage === this.nbPostsOffset / 2
        ? 2
        : this.page;
    this.itemsPerPage =
      this.page <= 2 ? this.nbPostsOffset / 2 : this.nbPostsOffset;
    this.page = pageTmp;
    const request$ =
      this.requestType === "favorites"
        ? this.favoriteRequest
        : this.postService.getPostsFlux(
            this.requestType,
            this.requestType === "kazacafe"
              ? this.getKazacafeParams()
              : this.params
          );

    return request$.pipe(
      finalize(() => {
        this.postLoading = false;
        this.requestDoneOnce = true;
        this.cdr.detectChanges();
      }),
      catchError(err => {
        this.toastrService.error(
          $localize`:@@toast.could_not_load_next_posts:Could not load the next publications`
        );
        return throwError(err);
      }),
      tap(posts => {
        if (this.page > 1) {
          this.offsetLoaded.emit((this.page - 1) * this.itemsPerPage);
          this.cdr.detectChanges();
        }
        // remove duplicate posts
        const newMedias =
          this.postsList && this.page > 1
            ? posts[hydraMember].filter(
                post => !this.postsList.find(m => m["@id"] === post["@id"])
              )
            : posts[hydraMember];
        const postsListB =
          this.page > 1
            ? [...this.postsList, ...newMedias]
            : posts[hydraMember];
        this.postsList = postsListB;
        this.cdr.detectChanges();
        this.postsFound.emit(this.postsList.length > 0);
        this.count.emit(posts["hydra:totalItems"]);
      })
    );
  }

  removePost(postId: string) {
    this.postsList = this.postsList.filter(post => post["@id"] !== postId);
    this.cdr.detectChanges();
  }

  onScroll() {
    if (this.postsList && this.postsList.length && !this.postLoading) {
      this.postsSubscription = this.updatePostList().subscribe();
    }
  }

  splitPostArray(nbcols: number, col: number) {
    return this.postsList.filter((el, index) => index % nbcols === col - 1);
  }

  numberReturn(length) {
    if (!isPlatformBrowser(this.platformId)) {
      return new Array(4);
    }
    return new Array(length);
  }

  getKazacafeParams() {
    const kazacafeParams = {
      itemsPerPage: this.itemsPerPage,
      page: this.page
    };
    return kazacafeParams;
  }

  redirect(): void {}

  trackPost(index: number, item: DisplayPost): string {
    return !item ? null : item["@id"];
  }
  getMyKazaPosts(): void {
    const params = {
      itemsPerPage: 1,
      page: 1,
      order: { createdAt: RequestOrder.DESC },
      privacy: null,
      kaza: this.userStoreService?.user?.activeKaza["@id"],
      author: null
    };
      this.myTagsSubscription =  this.userStoreService.userStore.pipe(
        filterNullOrUndefined(),
        switchMap(()=>{
          return this.postService.getPostsFlux(this.requestType, params)
        })
      ).subscribe({
        next: data => {
          this.userStoreService.userTags = data["hydra:member"][0]?.tags;
        }
      })
  }
  openModalInfo(): void {
    const modal = this._modalService.open<ModalScreenTutoComponent>(
      ModalScreenTutoComponent,
      {
        size: "md",
        closeButton: true
      }
    );
    modal
      .afterClosed()
      .pipe(
        tap(() => { }),
        take(1)
      )
      .subscribe();
  }
  downloadScreenShot() {
    this.sharedService.downloadedScreenShot = true;
    this.screenIsDownloading = true;
    this.cdr.detectChanges()
    setTimeout(() => {
      this.screenIsDownloading = false;
      this.cdr.detectChanges()
    }, 10000);
  }
  downloadPictures(): void {
    if (this.isDownloading) return;
    this.isDownloading = true;
    this.cdr.detectChanges(); 
    this.downloadSubscription = this.userStoreService.userStoreKazaStats.pipe(
      filterNullOrUndefined(),
      take(1),
      switchMap((kazaStats) => {
        const totalPictures = kazaStats.nbPictures;
        const picturesPerPage = 50;
        const totalPages = Math.ceil(totalPictures / picturesPerPage);
  
        const downloadRequests: Observable<any>[] = [];
        console.log(totalPages);
        for (let page = 1; page <= totalPages; page++) {
          downloadRequests.push(this.sharedService.downloadPics(page));
        }
        return forkJoin(
          downloadRequests.map(req => req.pipe(
            catchError(error => {
              console.error('Download Error:', error);
              return of(null); 
            })
          ))
        );
      }),
      finalize(() => {
        this.isDownloading = false;
        this.cdr.detectChanges(); 
      })
    ).subscribe({
      next: (zipFiles: Blob[]) => {
        zipFiles.forEach((data, index) => {
          setTimeout(() => {
            const blob = new Blob([data], { type: 'application/zip' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `photos_${index + 1}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }, index * 500);
        });
  
        this.toastrService.info('Tous les téléchargements sont terminés avec succès');
      },
      error: (error) => {
        this.toastrService.error('Une erreur est survenue. Veuillez réessayer');
      }
    });
  }
}
